export interface ISystemIncentive {
  systemIncentiveId: number;
  code: string;
  date: Date;
  identifier: number;
}

export class SystemIncentive implements ISystemIncentive {
  public systemIncentiveId: number;
  public code: string;
  public date: Date;
  public identifier: number;

  public constructor(id: number) {
    this.systemIncentiveId = id;
    this.identifier = Math.abs(id);
  }
}
